import React, { FC, useEffect } from 'react';

import { IGlobalState } from './global-state.interface';
import { useStore } from '@/store/';

const GlobalState: FC<IGlobalState> = ({ children, cartData, viewDefinitionResults, kamFlags }) => {
  const updateCartData = useStore(({ setCartData }) => setCartData);
  const updateViewDefinition = useStore(({ setViewDefinition }) => setViewDefinition);
  const updateKamFlags = useStore(({ setKamFlags }) => setKamFlags);

  // wrapped in useEffect to avoid hydration errors
  useEffect(() => {
    updateCartData(cartData!);
    updateViewDefinition(viewDefinitionResults!);
    updateKamFlags(kamFlags || null);
  }, [cartData, viewDefinitionResults, kamFlags, updateCartData, updateViewDefinition, updateKamFlags]);

  return <>{children}</>;
};

export default GlobalState;
